<template>
  <div class="content">
    <div class="title">小程序订单</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部" name="-1"></el-tab-pane>
      <el-tab-pane label="待出票" name="3"></el-tab-pane>
      <el-tab-pane label="已出票" name="4"></el-tab-pane>
      <el-tab-pane label="已结算" name="5"></el-tab-pane>
      <el-tab-pane label="已关闭" name="10"></el-tab-pane>
    </el-tabs>
    <Search :searchForm="searchForm"
            :searchList="searchList"
            :optionsType="optionsType"
            :hiddenExport="true"
            :exportLoading="exportLoading"></Search>
    <!--    表格-->
    <el-table
      class="table"
      v-loading="searchForm.Loading"
      :data="tableList.list"
      border
      highlight-current-row
      style="width: 100%;"
      header-row-class-name="header"
    >
      <el-table-column type="index" label="序号"  width="55" :index="indexMethod" align="center"/>
      <el-table-column
        v-for="(item,index) in tableData"
        :key="index"
        :prop="item.value"
        :label="item.text"
        align="center"
      >
        <template slot-scope="{row}">
          <span v-if="item.value === 'orderId'" class="click" @click="detail(row)">{{row[item.value]}}</span>
          <span v-else-if="item.value === 'num'">{{((row.orderPrice/row.initPrice) * 100).toFixed(2)}}%</span>
          <span v-else-if="item.value === 'commissionRate'">{{row.commissionRate}}%</span>
          <span v-else>{{row[item.value]}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="影票信息"
        align="center"
        fixed="right"
      >
        <template slot-scope="{row}">
          <span class="look" @click="detail(row)">查看</span>
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        label="操作"-->
<!--        align="center"-->
<!--        fixed="right"-->
<!--      >-->
<!--        <template slot-scope="{row}">-->
<!--          &lt;!&ndash; 待出票，非秒出单，未发起拦截或者取消拦截，才能发起拦截 &ndash;&gt;-->
<!--          <span class="span" v-if="row.orderStatus == 3 && row.orderType != 3 && (row.interceptOrderStatus === null || row.interceptOrderStatus == 5)" @click="intercept(row)">拦截订单</span>-->
<!--          <span class="span" v-if="row.orderStatus == 3 && row.orderType != 3 &&  [0,3,4].includes(row.interceptOrderStatus)" @click="cancelIntercept(row)">取消拦截</span>-->
<!--          &lt;!&ndash; 待出票，非秒出单，近10分钟未催票过，才能发起催票 &ndash;&gt;-->
<!--          <span class="span" v-if="row.orderStatus == 3 && row.orderType != 3 && !row.remindLog" @click="pushOut(row)">催出票</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <!--    分页-->
    <el-pagination
      v-if="tableList.total > 0"
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="tableList.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableList.total">
    </el-pagination>
    <!--   影票详情-->
    <detail v-if="detailShow" :detailShow="detailShow" :detailInfo="detailInfo"></detail>
    <!--  拦截-->
    <el-dialog
      :title="isPushOut?'催出票':'拦截订单'"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <div class="dialog">
        <div v-if="isPushOut">
          <div class="dialog-text">确认催出票？</div>
          <div class="dialog-text">每个订单10分钟内只能发起一次催出票</div>
        </div>
        <div style="display: flex" v-else>
          <div class="dialog-text">拦截原因</div>
          <textarea class="textarea" v-model="remark"></textarea>
        </div>
        <div class="dialog-button">
          <div class="button-cancel" @click="dialogVisible = false">取消</div>
          <div class="button-success" @click="confirm()">确定</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="取消拦截"
      :visible.sync="dialogVisibleCancel"
      width="40%"
      :before-close="handleClose">
      <div class="dialog">
        <div>
          <div class="dialog-text">确认取消拦截？</div>
        </div>
        <div class="dialog-button">
          <div class="button-cancel" @click="dialogVisibleCancel = false">取消</div>
          <div class="button-success" @click="cancelOrder()">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Search from "@/components/Search";
import mini from "@/api/mini";
const MiniModel = new mini()
import detail from "./components/detail";

export default {
  name: "index",
  components:{
    Search,
    detail
  },
  data(){
    return{
      activeName:'-1',
      exportLoading: false,
      searchForm: {
        appKey: localStorage.getItem('appKeyMini'),
        interceptStatus: '',
        nickName: '',
        orderCreateEndTime: '',
        orderCreateStartTime: '',
        orderId: '',
        orderStatus: '',
        pageSize: 10,
        pageNo: 1,
        total: '',
        Loading: true,
        time:'',
        orderType:1,
      },
      dialogVisible:false,
      searchList: [
        {
          id: 'orderId',
          text: '订单号',
          placeholder: '请输入订单号',
          type: 'input'
        }, {
          id: 'nickName',
          text: '用户昵称',
          placeholder: '请选择用户名称',
          type: 'input'
        }, {
          id: 'interceptOrderStatus',
          text: '拦截状态',
          placeholder: '请选择拦截状态',
          type: 'select'
        }, {
          id: 'time',
          text: '下单日期',
          type: 'timeOrder'
        },
        {
          id: 'selectType',
          text: '下单订单类型',
          type: 'selectType'
        }
      ],
      // 表头
      tableData: [{
        text: '订单ID',
        value: 'orderId',
      }
        // , {
        //   text: '下单用户',
        //   value: 'nickName',
        // }
        , {
          text: '市场价（元）',
          value: 'initPrice',
        }
        // , {
        //   text: '支付金额（元）',
        //   value: 'payAmount',
        // }
        // , {
        //   text: '折扣率',
        //   value: 'num',
        // }
        // ,{
        //   text: '成本价（元）',
        //   value: 'costPrice',
        // }
        ,
        // {
        //   text: '总佣金（元）',
        //   value: 'commission',
        // },{
        //   text: '分润佣金（元）',
        //   value: 'appCommission',
        // },{
        //   text: '佣金比例',
        //   value: 'commissionRate',
        // },
        {
          text: '订单状态',
          value: 'orderStatusStr',
        },
        // {
        //   text: '订单类型',
        //   value: 'orderTypeStr',
        // },
        {
          text: '拦截状态',
          value: 'interceptOrderStatusStr',
        },{
          text: '接受调座',
          value: 'acceptChangeSeatStr',
        },{
          text: '出票时间',
          value: 'ticketDurationStr',
        },{
          text: '创建时间',
          value: 'orderCreateTimeStr',
        }
      ],
      tableList:[],
      currentPage:1,
      detailShow:false,
      detailInfo: {}, // 详情
      remark: '',
      item: {},
      isPushOut:false,
      optionsType:[
        {
          label:'未拦截',
          value:0
        },{
          label:'拦截中',
          value:1
        },{
          label:'拦截成功',
          value:2
        },{
          label:'拦截失败',
          value:3
        }
      ],
      dialogVisibleCancel:false,
      isIntercept:false
    }
  },
  mounted() {
    if(this.$route.query.name){
      this.searchForm.nickName = this.$route.query.name
    }
    // 判断是否高亮
    if(this.path === '/pc/bypassAccountOrder/miniOrder'){
      this.$parent.isActive = 2
    }
    this.$parent.activeIndex = 2
    this.getList()
  },
  computed:{
    path:{
      get(){
        return this.$route.path
      }
    }
  },
  methods:{
    getList(){
      MiniModel.getOrderList(this.searchForm).then(res=>{
        this.searchForm.Loading = false
        if (res.data.code == 200) {
          this.tableList = res.data.data
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    handleClick(e){
      console.log(e)
      if(e.name == -1){
        this.searchForm.orderStatus = ''
      }else {
        this.searchForm.orderStatus = e.name
      }
      this.getList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
      this.getList()
    },
    handleClose(){
      this.dialogVisible = false
      this.dialogVisibleCancel =false
    },
    // 序号
    indexMethod(index) {
      index = (index + 1) + (this.searchForm.pageNo - 1) * this.searchForm.pageSize
      return index
    },
    detail(item){
      console.log('item',item)
      let param = {
        orderId:item.orderId
      }
      MiniModel.getOrderDetail(param).then(res=>{
        if (res.data.code == 200) {
          this.detailInfo = res.data.data
          this.detailShow = true
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    intercept(row){
      this.dialogVisible = true
      this.isPushOut = false
      this.item = row
    },
    // 取消拦截
    cancelIntercept(row){
      this.dialogVisibleCancel = true
      this.item = row
    },
    cancelOrder(){
      let params = {
        appKey:localStorage.getItem('appKeyMini'),
        orderUUID: this.item.orderUUID
      }
      MiniModel.cancelIntercept(params).then(res=>{
        if (res.data.code == 200) {
          this.$message.success('发起成功')
          this.dialogVisibleCancel = false
          this.getList()
        } else {
          this.$message.error(res.data.info || res.data.message || res.data.data.message)
        }
      })
    },
    confirm(){
      if(this.isPushOut){
        let params = {
          appKey:localStorage.getItem('appKeyMini'),
          orderUUID: this.item.orderUUID,
          urgeSource:2
        }
        MiniModel.pushOut(params).then(res=>{
          if (res.data.code == 200) {
            this.$message.success('发起成功')
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.data.info || res.data.message || res.data.data.message)
          }
        })
      }else {
        if(this.remark == ''){
          this.$message.error('请输入备注')
          return
        }
        if(!this.isIntercept){
          this.isIntercept = true
          let params = {
            interceptReason:this.remark,
            orderUUID: this.item.orderUUID,
            sourceType:3
          }
          MiniModel.orderIntercept(params).then(res=>{
            this.isIntercept = false
            if (res.data.code == 200) {
              this.$message.success('拦截发起成功')
              this.dialogVisible = false
              this.getList()
            } else {
              this.$message.error(res.data.info || res.data.message || res.data.data.message)
            }
          })
        }
      }
    },
    pushOut(row){
      this.dialogVisible = true
      this.isPushOut = true
      this.item = row
    },
    // 导出
    async exportButton() {
      this.exportLoading = true
      MiniModel.exportMovieOrder(this.searchForm).then(async res => {
        const code = res.data.code
        const message = res.data.message
        if (code === 200) {
          await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if(action === 'confirm'){
                this.$router.push({ path: "/pc/exportCenter/index" });
              }
              this.exportLoading = false
            }
          });
        } else {
          this.$Message.error(message)
        }
      }).finally(()=>{
        this.exportLoading = false
      })
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      console.log(y + m + d)
      return y + m + d;
    },
  }
}
</script>

<style scoped lang="less">
.content{
  //width: 80%;
  background: #FFFFFF;
  border-radius: 8px;
  //padding: 20px;
  .title{
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 25px;
  }
}
.table{
  margin-top: 30px;
}
.detail{
  display: flex;
  align-items: center;
  .detail-item{
    display: flex;
    margin-top: 20px;
    .item-text{
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 20px;
      width: 70px;
      text-align: right;
      margin-right: 10px;
    }
    .item-span{
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 20px;
    }
  }
}
.dialog{
  //padding: 20px 80px;
  .dialog-title{
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 24px;
  }
  .dialog-text{
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
  }
  .textarea{
    border: 1px solid #e5e5e5;
    height: 100px;
    margin-left: 10px;
    width: 300px;
  }
  .dialog-button{
    display: flex;
    align-items: center;
    margin-top: 48px;
    justify-content: center;
    .button-success{
      width: 76px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
    .button-cancel{
      width: 76px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      margin-right: 10px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }
}
.pagination{
  margin-top: 20px;
  text-align: right;
}
.look{
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #3D9EFC;
  line-height: 18px;
  cursor: pointer;
}
.span{
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF9734;
  line-height: 18px;
  cursor: pointer;
}
.click{
  cursor: pointer;
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #EEEEEE;
}
/deep/.el-tabs__item.is-active{
  color: #FF8622!important;
}
/deep/.el-tabs__active-bar{
  background-color: #FF8622!important;
}
/deep/.el-tabs__item:hover{
  color: #FF8622!important;
}
/deep/.el-table th, .el-table tr{
  background-color: #FCFAF8;
}
/deep/.el-date-editor .el-range-separator{
  line-height: 25px!important;
}
/deep/.el-tabs__nav-wrap::after{
  height: 1px!important;
}
/deep/.el-date-editor .el-range__icon{
  line-height: 25px!important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/bypassAccountOrder/miniOrder.vue